export const ONLY_NUMBER_REGEX = /^\d+$/;
export const ALPHA_NUMERIC_REGEX = /^[a-zA-Z0-9]+$/;
export const ALPHA_NUMERIC_REGEX_WITH_SPACING = /^[a-zA-Z0-9\s]+$/;
export const ONLY_ALPHA_REGEX = /^[A-Za-z]+$/;

/** Regex to match non-alphanumeric chars (use with .replace() to strip them). */
export const NON_ALPHANUMERIC_REGEX = /[^a-zA-Z0-9]/g;

/** Input filter that strips non-alphanumeric characters. Use with ALPHA_NUMERIC_REGEX format. */
export const ALPHANUMERIC_INPUT_FILTER = (v) => (v || '').replace(NON_ALPHANUMERIC_REGEX, '');

/** Returns true if format is the alphanumeric regex (for validation/input filtering). */
export const isAlphanumericFormat = (format) => format === ALPHA_NUMERIC_REGEX;
